module.exports = __webpack_public_path__ + "img/full_logo_white.3f986b35.png";